import { useStaticQuery, graphql } from 'gatsby';

/* Site-wide settings from the `siteSettings` singleton.
 *
 * A static query rather than a page query because Nav, Footer, and the
 * contact page all need this — threading it through ten page queries
 * would be unmaintainable.
 *
 * Returns null when the document has not been created yet.
 * gatsby-source-sanity derives Gatsby node types from the *deployed
 * GraphQL schema*, not from documents, so this resolves cleanly to null
 * against an empty dataset and the build succeeds. Every consumer pairs
 * the result with FB.site from content/fallbacks.js.
 */
export function useSiteSettings() {
  const data = useStaticQuery(graphql`
    query SiteSettingsQuery {
      sanitySiteSettings(_id: { eq: "siteSettings" }) {
        legalName {
          english
          french
        }
        rightsReserved {
          english
          french
        }
        missionStatement {
          english
          french
        }
        phone
        email
        address {
          lines
          mapQuery
        }
        socialLinks {
          platform
          url
        }
        navItems {
          placement
          route
          label {
            english
            french
          }
        }
      }
    }
  `);

  return data?.sanitySiteSettings || null;
}

export default useSiteSettings;
